import { Stack } from '@mui/material';
import { FormikProvider, useFormikContext } from 'formik';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import RoundedButton from '@components/RoundedButton';

import { useCuration } from '@hooks/useCuration';
import { useSession } from '@hooks/useSession';

const messages = defineMessages({
  save: {
    id: 'GLOBAL.save',
    defaultMessage: 'Save',
  },
  saveAndPublish: {
    id: 'recordSubmitButton.saveAndPublish',
    defaultMessage: 'Save & Publish',
  },
});

const RecordSubmitButton = () => {
  const formik = useFormikContext();
  const { isSubmitting, setFieldValue, submitForm } = formik;
  const { formatMessage } = useIntl();
  const {
    state: { isCreating, isEditing },
  } = useCuration();
  const {
    state: { isCurator },
  } = useSession();

  const handleSave = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setFieldValue('toPublish', false);
    await submitForm();
  };

  const handleSaveAndPublish = async (
    e: React.MouseEvent<HTMLButtonElement>
  ) => {
    e.preventDefault();
    setFieldValue('toPublish', true);
    await submitForm();
  };
  const displaySaveBtn = isCurator || isEditing;
  const displaySavePublishBtn = isCreating;

  return (
    <FormikProvider value={formik}>
      {isCreating || isEditing ? (
        <Stack direction="row" sx={{ width: '100%' }}>
          {displaySaveBtn && (
            <RoundedButton
              disabled={isSubmitting}
              onClick={handleSave}
              type="submit"
              variant="white"
            >
              {formatMessage(messages.save)}
            </RoundedButton>
          )}

          {displaySavePublishBtn && (
            <RoundedButton
              disabled={isSubmitting}
              onClick={handleSaveAndPublish}
              type="submit"
            >
              {formatMessage(messages.saveAndPublish)}
            </RoundedButton>
          )}
        </Stack>
      ) : null}
    </FormikProvider>
  );
};

export default RecordSubmitButton;
